import styled from 'styled-components'
///////////////////// Table Styles Start ////////////////////////////
import { MultiSelect } from 'react-multi-select-component'

export const StyledMultiSelect = styled(MultiSelect)`
  position: relative;
  .rmsc .dropdown-content {
    position: absolute;
    z-index: 9999;
  }
  .multi-select-dropdown {
    position: absolute; /* Ensures dropdown is positioned above other elements */
    z-index: 9999; /* Ensures dropdown appears on top */
  }
`

export const UserBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 85%;
  //overflow-x: scroll;
  padding: 24px;
  margin-left: 15%;
`

export const UserTopSection = styled.div`
  min-height: 50px;
  width: 100%;
`

export const TableContainer = styled.div`
  overflow-x: auto;

  /* Set a max-width to prevent the container from becoming too wide */
  max-width: 100%;
`

export const Table = styled.table`
  border: 1px solid black;
  border-top: 0;

  border-collapse: collapse;
  table-layout: fixed;

  /* Set a max-width to prevent the table from becoming too wide */
  width: 100%;
  /* Set a min-width to ensure that the table remains visible even when its contents are narrow */
  min-width: 1000px; /* or whatever minimum width you want */
`

export const THead = styled.thead`
  background-color: #ff8701;
  color: white;
`

export const THeadRow = styled.tr`
  //border: 2px solid red;
  /* background-color: #ff8701;

  color: white; */
`

export const TH = styled.th`
  //border: 1px solid blue;
  min-width: 60px;
  padding: 4px;
`

export const TBody = styled.tbody`
  /* border: 1px solid red; */
`

export const TBodyRow = styled.tr`
  :hover {
    background-color: #ff8701;
    color: black;
    //color: white;
    border-color: white;
  }
`

export const TD = styled.td`
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-right: 1px solid gray;
  overflow-x: auto;
  //border: 1px solid blue;
  text-align: left;

  ::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const Button = styled.button`
  border: none;
  background-color: #ff8701;
  padding: 8px;
  border-radius: 4px;
  min-width: 100px;
  min-height: 30px;
  cursor: pointer;

  :hover {
    text-decoration: underline;
    font-weight: 700;
  }
`

export const PaginationmainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-top: 10px;
`

export const PaginationDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 20px;

  input {
    width: 35px;
    outline: none;

    :focus {
      background-color: #ff8701;
    }
  }

  @media (max-width: 480px) {
    gap: 6px;
  }

  @media (max-width: 340px) {
    gap: 2px;
  }

  @media (max-width: 330px) {
    flex-direction: column;
  }
`

export const PaginationButton = styled.button`
  padding: 8px 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background-color: #ff8701;
  min-width: 70px;
  border: none;
  cursor: pointer;
  :disabled {
    background-color: gray;
    color: white;
  }
`

export const UsersSpecialDiv = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 4px;

  span {
    border: 1px solid gray;
    border-radius: 8px;
    padding: 4px;
  }
`

export const ModalButton = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 8px;
  padding: 8px;
  background-color: #ff8701;
  width: fit-content;
  cursor: pointer;

  font-weight: bold;
`

export const PaginationInputDiv = styled.div`
  input {
    border-radius: 4px;
    text-align: center;
  }
`

export const ActionSpan = styled.span`
  display: flex;
  justify-content: space-around;
  button {
    border: none;
    background-color: transparent;
    width: fit-content;
    cursor: pointer;
    img {
      width: 50%;
    }
  }
`

export const StyledSelect = styled.select`
  // Add your CSS styles here
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;

  option {
    padding: 8px;
  }
`

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
`

export const SearchInput = styled.input`
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 300px;
`

export const SearchButton = styled.button`
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  background-color: #007bff;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }
`

export const ResetButton = styled.button`
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  background-color: #dc3545;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-left: 10px;

  &:hover {
    background-color: #c82333;
  }
`

////////////////// Table Styles End /////////////////////////////////
